import styled, { css } from 'styled-components';

import { BODY_TEXT } from 'styles/color';
import { FONT_SIZE_14, FONT_WEIGHT_REGULAR, LETTER_SPACING_DENSE } from 'styles/tokens';
import { LINE_HEIGHT_CONDENSED_ULTRA } from 'styles/typography';

export const ellipsisCss = css`
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const TextCSS = css`
  color: ${BODY_TEXT};
  font-size: ${FONT_SIZE_14};
  font-weight: ${FONT_WEIGHT_REGULAR};
  letter-spacing: ${LETTER_SPACING_DENSE};
  line-height: ${LINE_HEIGHT_CONDENSED_ULTRA};
  position: relative;
  ${ellipsisCss}

  &:empty {
    display: none;
  }
`;

// TODO: When element values in a Text component are truncated, we'll need a tooltip to show the full value on hover
const Text = styled.div`
  ${TextCSS}
`;

export default Text;
